import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import type { FileInputProps } from '@sato/components';

import { OmaSATOFileInput } from '@components/OmaSATOFileInput';

type Props = {
  name: string;
  required?: boolean;
} & Partial<FileInputProps>;

export const HookFormFileInput = ({
  name,
  required,
  label,
  ...fileInputProps
}: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <OmaSATOFileInput
          {...fileInputProps}
          value={field.value}
          label={required ? `${label} *` : label}
          onChange={(value: File[]) => {
            field.onChange(value);
            fileInputProps?.onChange?.(value);
          }}
          error={fieldState.error?.message}
        />
      )}
    />
  );
};
